module.exports = __webpack_public_path__ + "static/source-sans-pro-v13-latin-ext_latin-700-6c142c18187b874f0b122714a5efc25a.ttf";